import type { OfferFormDataT, OfferPricingT } from "@/app/types/offers";

/**
 * Get the primary monthly leasing rate used for price display.
 *
 * Maintenance and inspection costs stay separate and must not be added to the
 * displayed leasing price.
 *
 * @param pricingOrOffer - Either the pricing object or the full offer data containing pricing information
 * @returns Base monthly leasing rate or null if not applicable
 */
export const getTotalMonthlyLeasingRate = (
  pricingOrOffer: OfferPricingT | OfferFormDataT | null | undefined
): number | null => {
  if (!pricingOrOffer) {
    return null;
  }

  // Check if it's an OfferFormDataT (has pricing property) or OfferPricingT
  const pricing =
    "pricing" in pricingOrOffer
      ? (pricingOrOffer as OfferFormDataT).pricing
      : (pricingOrOffer as OfferPricingT);

  if (!pricing || pricing.type !== "leasing") {
    return null;
  }

  const leasing = pricing.leasing;
  if (!leasing) {
    return null;
  }

  const baseLeasingRate = leasing.mtlLeasingrate ?? 0;
  return baseLeasingRate > 0 ? baseLeasingRate : null;
};
